import { trpc } from "utils/trpc";

export function useGetApplicationSettingsQuery(
  ops: Parameters<typeof trpc.noAuth.getApplicationSettings.useQuery>[1] = {},
) {
  return trpc.noAuth.getApplicationSettings.useQuery(undefined, ops);
}

export function useApplicationSettings() {
  const getApplicationSettingsQuery = useGetApplicationSettingsQuery();
  return getApplicationSettingsQuery.data || ({} as typeof getApplicationSettingsQuery.data);
}
